import React, { useEffect, useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { RadioGroup } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { connect } from "react-redux";
import axios from "axios";
import API_ENDPOINT from "../../../wm.api.service";

import {
  addCategoryCheck,
  getCategory,
} from "../../../services/actions/actions";

function AddedCategoriesList({
  list,
  className,
  checkBoxHandler,
  isFetchCat,
  getCategory,
  filterVal,
  onClickHitApi
}) {
  const set = (e, idx, list) => {
    checkBoxHandler(idx, list, e.target.checked);
  };
  const getCategoryList = () => {
    axios({
      method: "GET",
      url: `${API_ENDPOINT.apiURL}Profile/getCategoryList`,
    })
      .then(function (response) {
        if (getCategory) {
          getCategory(response.data);
          onClickHitApi();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    if (!isFetchCat) {
      getCategoryList();
    }
  }, []);
  return (
    <React.Fragment>
      <div className="addedCategoriesList w-full p-3">
        <div
          className={`addedCategoriesList__container border rounded-sm w-full py-3 px-2 max-h-40 overflow-auto ${className}`}
        >
          {list
            ?.filter((x) => x["value"].toLowerCase().includes(filterVal.toLowerCase()))
            .map((list, idx) => {
              return (
                <RadioGroup
                  key={idx}
                  aria-label="category"
                  name="category"
                  value={list}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={list.value}
                        checked={list.status}
                        onChange={(e) => {
                          set(e, idx, list);
                        }}
                      />
                    }
                    label={list.value}
                  />
                </RadioGroup>
              );
            })}
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    handleCategoryCheck: (idx, value) => {
      dispatch(addCategoryCheck(idx, value));
    },
    getCategoryFormApi: (idx, value) => {
      dispatch(getCategory(idx, value));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToState
)(AddedCategoriesList);
